import React from "react";
import { IconWithInclusionType } from "@flights/search-ui";
import { Stack, Text } from "@bookingcom/bui-react";
function FlightDetailsInfoMobileUI(props) {
    const { children, ...rest } = props;
    return React.createElement(Stack, { ...rest }, children);
}
function FlightDetailsInfoTitleMobileUI(props) {
    const { children, ...rest } = props;
    return (React.createElement(Text, { tagName: "h3", variant: "body_2", color: "neutral_alt", ...rest }, children));
}
function FlightDetailsInfoItemMobileUI(props) {
    const { children, svg, inclusionType, ...rest } = props;
    return (React.createElement(Stack, { gap: 2, direction: "row", ...rest },
        React.createElement(Stack.Item, null,
            React.createElement(IconWithInclusionType, { svg: svg, inclusionType: inclusionType || "__HIDDEN" })),
        React.createElement(Stack.Item, { grow: true, mixin: { paddingBlockStart: 0.5 } },
            React.createElement(Text, { variant: "body_2" }, children))));
}
FlightDetailsInfoMobileUI.Title = FlightDetailsInfoTitleMobileUI;
FlightDetailsInfoMobileUI.Item = FlightDetailsInfoItemMobileUI;
export { FlightDetailsInfoMobileUI };
